import _createForOfIteratorHelper from "D:/git/aexdo_frontend_local/aexdo_frontend/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "D:/git/aexdo_frontend_local/aexdo_frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "D:/git/aexdo_frontend_local/aexdo_frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import * as React from 'react';
import { useContext, useEffect, useMemo, useState, useRef } from 'react';
import { cloneElement } from 'react';
import { MapContext } from './map';
import assert from '../utils/assert';
import { deepEqual } from '../utils/deep-equal';
var sourceCounter = 0;

function createSource(map, id, props) {
  // @ts-ignore
  if (map.style && map.style._loaded) {
    var options = _objectSpread({}, props);

    delete options.id;
    delete options.children; // @ts-ignore

    map.addSource(id, options);
    return map.getSource(id);
  }

  return null;
}
/* eslint-disable complexity */


function updateSource(source, props, prevProps) {
  assert(props.id === prevProps.id, 'source id changed');
  assert(props.type === prevProps.type, 'source type changed');
  var changedKey = '';
  var changedKeyCount = 0;

  for (var key in props) {
    if (key !== 'children' && key !== 'id' && !deepEqual(prevProps[key], props[key])) {
      changedKey = key;
      changedKeyCount++;
    }
  }

  if (!changedKeyCount) {
    return;
  }

  var type = props.type;

  if (type === 'geojson') {
    source.setData(props.data);
  } else if (type === 'image') {
    source.updateImage({
      url: props.url,
      coordinates: props.coordinates
    });
  } else if ((type === 'canvas' || type === 'video') && changedKeyCount === 1 && changedKey === 'coordinates') {
    source.setCoordinates(props.coordinates);
  } else if (type === 'vector' && 'setUrl' in source) {
    // Added in 1.12.0:
    // vectorTileSource.setTiles
    // vectorTileSource.setUrl
    switch (changedKey) {
      case 'url':
        source.setUrl(props.url);
        break;

      case 'tiles':
        source.setTiles(props.tiles);
        break;

      default:
    }
  } else {
    // eslint-disable-next-line
    console.warn("Unable to update <Source> prop: ".concat(changedKey));
  }
}
/* eslint-enable complexity */


function Source(props) {
  var map = useContext(MapContext).map.getMap();
  var propsRef = useRef(props);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      setStyleLoaded = _useState2[1];

  var id = useMemo(function () {
    return props.id || "jsx-source-".concat(sourceCounter++);
  }, []);
  useEffect(function () {
    if (map) {
      var forceUpdate = function forceUpdate() {
        return setStyleLoaded(function (version) {
          return version + 1;
        });
      };

      map.on('styledata', forceUpdate);
      forceUpdate();
      return function () {
        var _a;

        map.off('styledata', forceUpdate); // @ts-ignore

        if (map.style && map.style._loaded && map.getSource(id)) {
          // Parent effects are destroyed before child ones, see
          // https://github.com/facebook/react/issues/16728
          // Source can only be removed after all child layers are removed
          var allLayers = (_a = map.getStyle()) === null || _a === void 0 ? void 0 : _a.layers;

          if (allLayers) {
            var _iterator = _createForOfIteratorHelper(allLayers),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var layer = _step.value;

                // @ts-ignore (2339) source does not exist on all layer types
                if (layer.source === id) {
                  map.removeLayer(layer.id);
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }

          map.removeSource(id);
        }
      };
    }

    return undefined;
  }, [map]); // @ts-ignore

  var source = map && map.style && map.getSource(id);

  if (source) {
    updateSource(source, props, propsRef.current);
  } else {
    source = createSource(map, id, props);
  }

  propsRef.current = props;
  return source && React.Children.map(props.children, function (child) {
    return child && cloneElement(child, {
      source: id
    });
  }) || null;
}

export default Source;